/* eslint-disable */
import * as React from 'react';
const SvgKulaDarkLogo = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.9847 0H6.01528C2.69313 0 0 2.69313 0 6.01528V17.9847C0 21.3069 2.69313 24 6.01528 24H17.9847C21.3069 24 24 21.3069 24 17.9847V6.01528C24 2.69313 21.3069 0 17.9847 0Z"
      fill="#262244"
    />
    <path
      d="M17.6276 18.4158H17.5871C14.5055 18.4158 12.0078 15.9181 12.0078 12.8365V12.796C12.0078 12.3558 12.3643 11.9993 12.8046 11.9993H17.6234C18.0664 11.9993 18.425 12.3579 18.425 12.8009V17.6197C18.425 18.06 18.0685 18.4165 17.6283 18.4165L17.6276 18.4158Z"
      fill="white"
    />
    <path
      d="M8.01294 5.58276H7.98224C6.66176 5.58276 5.59131 6.65322 5.59131 7.97369V16.0256C5.59131 17.346 6.66176 18.4165 7.98224 18.4165H8.01294C9.33341 18.4165 10.4039 17.346 10.4039 16.0256V7.97369C10.4039 6.65322 9.33341 5.58276 8.01294 5.58276Z"
      fill="white"
    />
    <path
      d="M16.0339 5.58276H16.0032C14.6828 5.58276 13.6123 6.65322 13.6123 7.97369V8.00439C13.6123 9.32487 14.6828 10.3953 16.0032 10.3953H16.0339C17.3544 10.3953 18.4249 9.32487 18.4249 8.00439V7.97369C18.4249 6.65322 17.3544 5.58276 16.0339 5.58276Z"
      fill="white"
    />
  </svg>
);
export default SvgKulaDarkLogo;
